import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Spinner from './spinner/Spinner';

const SelectWithPicture = ({
    setSelectClub,
    selectClub,
    setTeams,
    setSelectTeam,
    getTeamsBasedOnSelectedClub,
    searchValue,
    setSearchValue,
    setNotFoundClubError,
    setTeamLogo,
    className = '',
    borderColor = '',
    userInfo = {},
    clubsByGender = false,
    onBlur
}) => {
    const [searchData, setSearchData] = useState([]);
    const [listOfClubs, setListOfClubs] = useState([]);
    const [showClubs, setShowClubs] = useState(false);

    const { clubModel, clubsByGenderAndType } = useSelector(({ club }) => ({
        clubModel: club,
        clubsByGenderAndType: club.clubsByGenderAndType
    }));

    const pickClubLoading = useSelector(
        ({ loading }) => loading.effects.team.getTeamsByClubId
    );

    const handleClubChange = selectedClub => {
        if (setTeamLogo) {
            setTeamLogo(selectedClub?.clubLogoUrl);
        }

        // if the club exists in the state and have ID then get the teams within this club
        if (selectedClub?.id) {
            setSelectClub(selectedClub || {});
            getTeamsBasedOnSelectedClub !== null &&
                getTeamsBasedOnSelectedClub(selectedClub.id);
        }

        // reset selected teams
        setTeams && setTeams([]);
        setSelectTeam && setSelectTeam({});
    };

    useEffect(() => {
        if (searchValue.length > 0) {
            const result = listOfClubs?.filter(club =>
                club?.clubName
                    ?.toLowerCase()
                    .includes(searchValue?.toLowerCase())
            );

            if (setNotFoundClubError) {
                setNotFoundClubError(result?.length === 0);
            }

            setShowClubs(result?.length > 0);

            setSearchData(result);
        }

        if (searchValue.length === 0) {
            setSearchData([]);
        }
    }, [searchValue, listOfClubs, setNotFoundClubError]);

    useEffect(() => {
        if (!clubsByGender) {
            setListOfClubs(clubModel?.allClubs);
        } else {
            setListOfClubs(clubsByGenderAndType);
        }
    }, [clubModel?.allClubs, clubsByGenderAndType, clubsByGender]);

    return (
        <>
            <div className='relative'>
                {selectClub?.clubLogoUrl && (
                    <img
                        src={selectClub.clubLogoUrl}
                        alt='Club Logo'
                        className='w-[20px] h-[20px]  absolute left-4 top-1/2 -translate-y-1/2 flex items-center'
                    />
                )}
                <input
                    onChange={event => {
                        setSearchValue(event.target.value);
                        setSelectClub({});
                    }}
                    onBlur={onBlur}
                    defaultValue={userInfo?.clubName}
                    className={`${selectClub?.clubLogoUrl ? 'pl-12' : 'pl-4'} ${
                        selectClub?.clubName ? 'pr-10' : 'pr-4'
                    } appearance-none text-[14px] bg-transparent border-b-2 ${borderColor || 'border-gray-600'} w-full text-[#000000] py-4 leading-[24px] focus:outline-none`}
                    type='text'
                    value={selectClub?.clubName || searchValue}
                    aria-label='clubName'
                    placeholder={userInfo?.clubName || 'Start typing...'}
                />
                {selectClub?.clubName && (
                    <button
                        type='button'
                        onClick={() => {
                            setSelectClub({});
                            setSearchValue('');
                            setTeams && setTeams([]);
                            setSelectTeam && setSelectTeam({});
                        }}
                        className='absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full transition-colors bg-transparent'
                        aria-label='Clear selection'
                    >
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M15 5L5 15M5 5L15 15'
                                stroke='currentColor'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                            />
                        </svg>
                    </button>
                )}
            </div>

            {showClubs && (
                <div
                    className={`absolute z-50 overflow-y-scroll text-[12px] max-h-[35vh] mt-1 bg-white w-full flex flex-col gap-5 rounded-xl ${className} px-4 shadow-2xl`}
                >
                    <ul className=''>
                        {searchData?.map(club => (
                            <li
                                onClick={() => {
                                    handleClubChange(club);
                                    setShowClubs(false);
                                }}
                                key={club.id}
                                className='pb-7 border-b-[2px] border-gray-200 flex my-7'
                            >
                                {pickClubLoading ? (
                                    <Spinner />
                                ) : (
                                    <img
                                        className='w-[28px] h-[28px] mr-5 object-contain'
                                        src={club.clubLogoUrl}
                                        alt=''
                                    />
                                )}
                                <p className='text-[14px] font-[400] leading-[24px] font-poppins text-center'>
                                    {club?.clubName}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
};

export default React.memo(SelectWithPicture);
